import { Order } from "@/entities/order";

export function getPanelName(order: Order, locale: string): string {
  if (!order?.form?.formConfig) {
    return order.formTestName ?? "";
  }

  let panelName = order.form.formConfig.panelName;

  if (
    locale !== "en" &&
    order.form?.formConfig?.localizations !== undefined &&
    order.form.formConfig.localizations[locale]?.panelName
  ) {
    panelName = order.form.formConfig.localizations[locale].panelName;
  }

  // fallback
  if (!panelName) {
    panelName = order.formTestName;
  }

  return panelName;
}

export function useLocalizationHelper() {
  return { getPanelName };
}
